<template>
  <div id="myCoupon">
    <div class="container">
      <div class="row">
        <div class="col-lg-offset-3 col-lg-6 col-md-offset-2 col-md-8 col-xs-12">
          <ul class="row nav nav-tabs">
            <li :class="['col-sm-4', 'col-xs-6', {'active': currentTab === 'usage'}]">
              <a href="#" @click.prevent="currentTab = 'usage'">이용권/쿠폰 이용내역</a>
            </li>
            <li :class="['col-sm-4', 'col-xs-6', {'active': currentTab === 'coupon'}]">
              <a href="#" @click.prevent="currentTab = 'coupon'">쿠폰함</a>
            </li>
          </ul>
          <div class="tab-content">
            <div id="usage" v-show="currentTab === 'usage'">
              <div class="card margin-bottom-32">
                <div class="card-header">
                  <p>{{ user.comp_name }} - {{ user.pic_name }}님</p>
                  <h4>{{ user.auth_level_name | nullCheck }}</h4>
                </div>
                <div class="card-body">
                  <p>이용권 종료일</p>
                  <h3>{{ user.expiration_date | nullCheck }}</h3>
                  <router-link to="/pricing" class="hz-btn-lg hz-btn-primary">이용권 구매</router-link>
                </div>
              </div>
              <div class="usage-log">
                <h5 class="margin-bottom-16">상세정보</h5>
                <div style="height: 500px; width: 100%;">
                  <kendo-grid ref="grid"
                              :columns="tableFields"
                              :auth="true"
                              :message="'사용 내역이 없습니다.'"
                              :dataUrl="baseUrl + '/biz/pricing/charge/'"></kendo-grid>
                </div>
              </div>
            </div>
            <div id="coupon" v-show="currentTab === 'coupon'">
              <div class="card coupon-info">
                <div class="row">
                  <div class="col-xs-4">
                    <p class="label-txt">보유중</p>
                    <p class="value-txt">{{ couponInventoryData.valid_coupon }}<small>개</small></p>
                  </div>
                  <div class="col-xs-4">
                    <p class="label-txt">만료예정</p>
                    <p class="value-txt">{{ couponInventoryData.expected_expire_coupon }}<small>개</small></p>
                  </div>
                  <div class="col-xs-4">
                    <p class="label-txt">누적혜택</p>
                    <p class="value-txt">
                      {{ couponInventoryData.benefit_days }}<small>일</small>
                      <span v-if="couponInventoryData.benefit_price !== ''" class="hidden-xs">{{ couponInventoryData.benefit_price | nullCheck }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="card coupon-add">
                <div class="table">
                  <div class="table-cell">
                    <label>쿠폰등록</label>
                  </div>
                  <div class="table-cell">
                    <input type="text"
                       placeholder="쿠폰코드를 입력해주세요."
                       maxlength="50"
                       :class="couponInputClass"
                       :readonly="couponRegistering"
                       @keyup.enter="addCoupon()"
                       v-model.trim="couponCode">
                    <button type="button" class="hz-btn-default hz-btn-lg" @click="addCoupon()">등록</button>
                    <p v-show="couponError" class="is-invalid-text">{{ couponErrorMessage }}</p>
                  </div>
                </div>
              </div>
              <div class="coupon-filter" v-if="couponInventoryData.results.length > 0">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" value="coupon" v-model="checkedFilter">
                    <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                    일반
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" value="event" v-model="checkedFilter">
                    <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                    이벤트
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" value="discount" v-model="checkedFilter">
                    <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                    할인
                  </label>
                </div>
              </div>
              <ul class="coupon-list">
                <li :class="['card', 'table', {'is-expire': coupon.is_expire}]"
                    v-for="coupon in filteredCouponList" :key="coupon.id">
                  <div class="table-cell tag-wrap">
                    <div :class="['coupon-tag', `coupon-tag-${coupon.type}`]">{{ coupon.type_string | nullCheck }}</div>
                  </div>
                  <div class="table-cell info-wrap">
                    <p class="coupon-name">{{ coupon.name }}</p>
                    <p :class="['coupon-desc', {'m-b-12': coupon.is_expected_expire || coupon.type === 'discount'}]">{{ coupon.desc }}</p>
                    <div v-if="coupon.is_expected_expire" class="purple-txt hidden-lg hidden-md hidden-sm">만료 예정</div>
                    <div v-if="coupon.type === 'discount'" class="purple-txt hidden-lg hidden-md hidden-sm">담당자통해 사용가능</div>
                  </div>
                  <div class="table-cell text-right hidden-xs" style="padding-right: 24px;">
                    <div v-if="coupon.is_expected_expire" class="purple-tag">만료 예정</div>
                    <div v-if="coupon.type === 'discount'" class="purple-txt">담당자통해 사용가능</div>
                  </div>
                  <div class="table-cell btn-wrap">
                    <button v-if="coupon.is_expire" type="button" title="기간이 만료되었습니다." class="hz-btn-primary hz-btn-md w-100" style="background-color: #e1e6f3; cursor: not-allowed;">만료됨</button>
                    <button v-else-if="coupon.type === 'discount'" type="button" class="hz-btn-primary hz-btn-md w-100" @click="$refs.discountModal.show()">구매문의</button>
                    <button v-else type="button" class="hz-btn-primary hz-btn-md w-100" @click="showUseCouponModal(coupon.id, coupon.add_days)">사용하기</button>
                    <p>등록만료 {{ coupon.event_expiration_date }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal ref="useCouponModal"
           :id="useCouponModal.id"
           :type="useCouponModal.type"
           :title="useCouponModal.title"
           :size="useCouponModal.size"
           :fields="useCouponModal.fields"
           @submit="useCoupon()"></modal>
    <modal ref="discountModal"
           :id="discountModal.id"
           :type="discountModal.type"
           :title="discountModal.title"
           :size="discountModal.size"
           :fields="discountModal.fields"
           @submit="$router.push({ name: 'product' })"></modal>
  </div>
</template>

<script>
  import KendoGrid from 'common/components/KendoGrid'
  import Loader from 'common/components/Loader'
  import Modal from 'common/components/Modal'
  import api from '@/api/coupon.js'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'mycoupon',
    components: {
      KendoGrid,
      Loader,
      Modal
    },
    data () {
      return {
        couponError: false,
        couponRegistering: false,
        loaderActive: true,
        baseUrl: location.protocol + '//' + location.hostname.replace('biz', 'api'),
        couponErrorMessage: '',
        currentTab: 'usage',
        couponCode: '',
        targetCouponId: '',
        couponTypes: {
          normal: '일반',
          event: '이벤트',
          discount: '할인',
          expire: '만료'
        },
        checkedFilter: ['coupon', 'event', 'discount'],
        couponInventoryData: {
          page: 1,
          count: 0,
          valid_coupon: 0,
          expected_expire_coupon: 0,
          benefit_days: 0,
          benefit_price: 0,
          results: []
        },
        discountModal: {
          id: 'discountModal',
          type: 'confirm',
          title: '쿠폰사용',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['제품구매 시 이용하실 수 있습니다.', '제품구매 페이지로 이동하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        useCouponModal: {
          id: 'useCouponModal',
          type: 'confirm',
          title: '쿠폰사용',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        },
        tableFields: [
          {
            field: 'reg_date',
            title: '등록일',
            type: 'date',
            width: '120px',
            format: '{0:yyyy.MM.dd}',
            sortable: false,
            filterable: false
          },
          {
            field: 'product_name',
            title: '이름',
            type: 'string',
            width: '150px',
            attributes: { class: 'show-tooltip' },
            sortable: false,
            filterable: false,
            template (item) {
              return item.product_name === '' ? '-' : item.product_name
            }
          },
          {
            field: 'product_desc',
            title: '내용',
            type: 'string',
            width: '100px',
            attributes: { class: 'show-tooltip' },
            sortable: false,
            filterable: false,
            template (item) {
              return item.product_desc === '' ? '-' : item.product_desc
            }
          },
          {
            field: 'expiration_date',
            title: '이용기간',
            type: 'string',
            attributes: { class: 'show-tooltip' },
            width: '200px',
            sortable: false,
            filterable: false,
            template: (item) => {
              const startDate = item.start_date
              const endDate = item.expiration_date.split('T')[0]

              // 할인쿠폰 일 경우 이용기간이 없으므로 '-' 처리한다.
              return item.type === 'discount' ? '-' : `${startDate} ~ ${endDate}`
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      }),
      couponInputClass () {
        const inputClass = ['hz-input-default', 'hz-input-lg', 'w-100']
        if (this.couponError) {
          inputClass.push('is-invalid')
        }

        return inputClass
      },
      filteredCouponList () {
        const checkedFilter = this.checkedFilter
        const couponList = this.couponInventoryData.results
        const filteredCouponList = couponList.filter(coupon => coupon.is_expire || checkedFilter.includes(coupon.type))

        return filteredCouponList
      }
    },
    watch: {
      couponCode () {
        // 쿠폰 입력 오류가 발생한 상황에서 코드르 새로 입력할 경우, 에러 초기화
        if (this.couponError) {
          this.couponError = false
          this.couponErrorMessage = ''
        }
      }
    },
    methods: {
      ...mapActions([
        'getPricingInfo',
        'showToastMessage'
      ]),
      addCoupon () {
        if (this.couponCode && !this.couponRegistering && !this.couponError) {
          this.couponRegistering = true

          // 쿠폰 등록 API 요청
          api.addCoupon({promotion_code: this.couponCode}, response => {
            if (response.error) {
              this.couponError = true
              this.couponRegistering = false
              this.couponErrorMessage = response.data.message
            } else {
              this.couponCode = ''
              this.couponErrorMessage = ''
              this.couponError = false
              this.couponRegistering = false
              this.getCouponInventory()
              this.showToastMessage('쿠폰 등록 완료')
            }
          })
        }
      },
      getCouponInventory () {
        api.getCouponInventory(response => {
          if (response.error) {
            this.showToastMessage('쿠폰목록 불러오기 실패 (관리자에게 문의)')
          } else {
            this.couponInventoryData = response.data
          }
        })
      },
      showUseCouponModal (couponId = '', addDays = 0) {
        if (couponId) {
          // 이용권 사용 시 이용잔여기간 계산
          const expirationDate = this.user.expiration_date.replace(/\./g, '-')
          const startDate = expirationDate === '' ? moment() : moment(expirationDate)
          const addedDate = startDate.add(addDays, 'days').format('YYYY-MM-DD')

          // 출력 메세지
          this.useCouponModal.fields[0].message = [
            '쿠폰 사용시 이용잔여기간은',
            `${addedDate}일이 됩니다.`,
            '쿠폰을 사용하시겠습니까?'
          ]

          // 사용할 쿠폰 ID
          this.targetCouponId = couponId

          this.$refs.useCouponModal.show()
        }
      },
      useCoupon () {
        api.useCoupon({ id: this.targetCouponId }, response => {
          if (response.error) {
            this.showToastMessage('쿠폰 사용하기 실패 (관리자에게 문의)')
          } else {
            // 데이터 업데이트
            this.getPricingInfo()
            this.getCouponInventory()
            this.$refs.grid.refresh()

            this.showToastMessage('쿠폰 사용 완료')
          }
        })
      }
    },
    created () {
      const token = localStorage.getItem('_t')

      if (!token) {
        this.$router.push({name: 'login'})
        this.$route.query.next = {name: 'mycoupon'}
        alert('로그인이 필요한 서비스입니다.')
        return false
      }

      // 토큰 유효성 검증
      this.$store.dispatch('inspectToken', token).then(() => {
        this.getCouponInventory()
      })
    },
    mounted () {
      const query = this.$route.query
      if (query.hasOwnProperty('tab')) {
        this.currentTab = query.tab
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/components/tab';

  #myCoupon {
    .container {
      padding: 80px 0;
      @media (max-width: $screen-xs-max) {
        padding: 40px 8px;
      }
    }

    .card {
      border-radius: 4px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px $hzc-gray-02;
      background-color: $hzc-white;
    }

    .nav-tabs {
      margin: 0 0 24px;
    }

    #usage {
      .card {
        &-header {
          padding: 24px;
          border-bottom: 1px solid #dee2e6;
          overflow: auto;

          h4 {
            width: 40%;
            margin: 0;
            padding: 0;
            font-size: 26px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: -1.4px;
            color: #2e3134;
            text-align: center;
            float: left;
          }

          p {
            width: 60%;
            margin: 0;
            padding: 6px 0;
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            color: $header-color;
            float: left;
          }

          @media (max-width: 767px) {
            h4, p {
              width: 100%;
              text-align: center;
            }
          }
        }

        &-body {
          padding: 24px;
          overflow: auto;

          h3 {
            width: calc(100% - 145px);
            margin : 8px 0 0 0;
            font-size: 32px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.25;
            letter-spacing: -1.6px;
            color: #39496b;
            float: left
          }

          p {
            margin: 0;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.71;
            letter-spacing: -0.7px;
            color: #54595f;
          }

          a {
            padding: 14px 16px;
            width: 145px;
            float: left;
          }

          @media (max-width: 767px) {
            h3, p, a {
              width: 100%;
              text-align: center;
            }

            h3 {
              margin: 8px 0 16px;
            }
          }
        }
      }
      .usage-log {
        h5 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.36;
          letter-spacing: -1.1px;
          color: #2e3134;
        }
      }
    }

    #coupon {
      .card {
        padding: 24px;
      }

      .table {
        display: table;
        margin: 0;
      }

      .table-cell {
        display: table-cell;
        vertical-align: middle;
      }

      .coupon-info {
        margin: 0 0 16px;
        padding: 24px;

        .col-xs-4 {
          padding: 0;
        }

        .label-txt {
          margin: 0 0 8px;
          font-size: 14px;
          font-weight: bold;
          line-height: 1.43;
          letter-spacing: -0.35px;
          color: $blue-grey;
        }

        .value-txt {
          margin: 0;
          font-size: 32px;
          font-weight: bold;
          line-height: 1.25;
          letter-spacing: -1.3px;
          color: $font-color;

          small {
            font-size: 16px;
          }

          span {
            margin: 0 0 0 16px;
            font-size: 12px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.33;
            letter-spacing: -0.3px;
            color: $blue-grey
          }
        }

        @media (max-width: $screen-xs-max) {
          text-align: center;
        }
      }

      .coupon-add {
        margin: 0 0 32px;
        padding: 24px;

        label {
          margin: 0;
          font-size: 14px;
          font-weight: bold;
          line-height: 1.43;
          letter-spacing: -0.35px;
          color: $font-color;
        }

        input {
          width: calc(100% - 100px);
        }

        button {
          width: 97px;
        }

        @media (max-width: $screen-xs-max) {
          padding: 16px;

          .table-cell {
            display: block;
          }

          label {
            margin: 0 0 8px;
          }
        }
      }

      .coupon-filter {
        margin: 0 0 16px;
        text-align: right;

        .checkbox {
          display: inline-block;
          margin: 0 0 0 24px;
        }
      }

      .coupon-list {
        margin: 0;
        padding: 0;
        list-style: none;

        .card {
          margin: 0 0 16px;
          padding: 0;
          border-color: $border-color;

          @media (max-width: $screen-xs-max) {
            height: 116px;
            margin: 0 0 8px;
          }
        }

        .purple-txt {
          margin: 4px 0;
          font-size: 12px;
          line-height: 1.33;
          letter-spacing: -0.3px;
          color: $purple;
        }

        .purple-tag {
          display: inline-block;
          width: 64px;
          height: 26px;
          margin: 4px 0;
          border-radius: 13px;
          background-color: #f5f2fc;
          font-size: 12px;
          font-weight: bold;
          line-height: 26px;
          letter-spacing: -0.3px;
          text-align: center;
          color: $purple;
        }

        .tag-wrap {
          width: 88px;
          padding: 24px;

          .coupon-tag {
            width: 40px;
            height: 40px;
            border-radius: 9px;
            text-align: center;
            font-size: 12px;
            font-weight: bold;
            letter-spacing: -0.3px;
            line-height: 40px;

            &-coupon {
              background-color: #e1e6f3;
              color: $primary-color-v2;
            }

            &-event {
              background-color: $hzc-yellow-00;
              color: $hzc-yellow-06;
            }

            &-discount {
              background-color: #ffe3d6;
              color: $orange;
            }
          }

          @media (max-width: $screen-xs-max) {
            width: 60px;
            padding: 8px;
          }
        }

        .info-wrap {
          .coupon-name {
            margin: 0 0 8px;
            font-size: 14px;
            font-weight: bold;
            line-height: 1.43;
            letter-spacing: -0.35px;
            color: $font-color;

            @media (max-width: $screen-xs-max) {
              margin: 0 0 4px;
            }
          }

          .coupon-desc {
            margin: 0;
            font-size: 22px;
            font-weight: bold;
            line-height: 1.36;
            letter-spacing: -0.9px;
            color: $font-color;

            @media (max-width: $screen-xs-max) {
              &.m-b-12 {
                margin-bottom: 12px;
              }
            }
          }
        }

        .btn-wrap {
          width: 158px;
          padding: 24px;
          background-color: $light-grey;

          button {
            margin: 0 0 10px;
          }

          p {
            margin: 0;
            font-size: 12px;
            line-height: 1.33;
            letter-spacing: -0.3px;
            color: $blue-grey;
          }

          @media (max-width: $screen-xs-max) {
            width: 140px;
            padding: 16px;
          }
        }
      }

      .is-expire {
        .coupon-name, .coupon-desc {
          color: $hzc-gray-05 !important;
        }

        .coupon-tag {
          background-color: $hzc-gray-02 !important;
          color: $hzc-gray-05 !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/MyCoupon.vue